import Footer from '../components/Footer'
import MatriChatList from '../components/MatriChatList'
import MatrimonyHeader from '../components/MatrimonyHeader'
import MatriMyProfileHero from "../components/MatriMyProfileHero"
import React from 'react'

function ChatList() {
  return (
    <div>
        <MatrimonyHeader />
        <MatriMyProfileHero />
        <MatriChatList />
        <Footer />
    </div>
  )
}

export default ChatList